module.exports = __webpack_public_path__ + "img/01.b8f58dd8.jpg";